import React from "react";
import {UsersActivity} from "./UsersActivity";

export const UsersActivityWidget = () => {
    return (
        <div className={'statistic-widget users'}>
            <UsersActivity/>
        </div>
    );
}